/*
 * @Author: cuihaonan
 * @Email: devcui@outlook.com
 * @Date: 2021-04-07 13:55:19
 * @LastEditTime: 2021-04-07 14:08:24
 * @LastEditors: cuihaonan
 * @Description: Basic description
 * @FilePath: /angular-mobile-npm-package/projects/ng-yunzai-mobile/devices/device.service.ts
 * @LICENSE: NONE
 */
import {Inject, Injectable, Injector, OnInit} from "@angular/core";
import {BaseDevice} from "./base.device";
import {Android} from "./android";
import {IOS} from "./ios";
import {WechatMp} from "./wechat.mp";
import {WechatMicro} from "./wechat.micro";
import {Browser} from "./browser";
import {Yiban} from "./yiban";
import {YunzaiIm} from "./yunzai.im";
import {Dingtalk} from "./dingtalk";
import {BASE_CLIENT, BaseClient} from "../client";

/**
 * 设备类型
 */
export enum DeviceType {
  // 浏览器
  BROWSER = "BROWSER",
  // 苹果
  IOS = "IOS",
  // 安卓
  ANDROID = "ANDROID",
  // 公众号
  WECHAT_MP = "WECHAT_MP",
  // 小程序
  WECHAT_MICRO = "WECHAT_MICRO",
  // YIBAN
  YIBAN = "YIBAN",
  // YUNZAI_IM
  YUNZAI_IM = "YUNZAI_IM",
  // 钉钉
  DINGTALK = "DINGTALK",
}

declare let wx: any;

@Injectable({
  providedIn: "root",
})
export class DeviceService implements OnInit {
  native: BaseDevice;

  ngOnInit(): void {
  }

  // tslint:disable-next-line: no-use-before-declare
  constructor(private inject: Injector,
              @Inject(BASE_CLIENT) private baseclient: BaseClient
  ) {

    if (this.baseclient.alwaysBrowser) {
      this.native = this.inject.get(Browser);
      return;
    }

    switch (this.getType()) {
      case DeviceType.YIBAN:
        this.native = this.inject.get(Yiban);
        break;
      case DeviceType.ANDROID:
        this.native = this.inject.get(Android);
        break;
      case DeviceType.IOS:
        this.native = this.inject.get(IOS);
        break;
      case DeviceType.YUNZAI_IM:
        this.native = this.inject.get(YunzaiIm);
        break;
      case DeviceType.DINGTALK:
        this.native = this.inject.get(Dingtalk);
        break;
      case DeviceType.WECHAT_MP:
        this.native = this.inject.get(WechatMp);
        break;
      case DeviceType.WECHAT_MICRO:
        this.native = this.inject.get(WechatMicro);
        break;
      default:
        this.native = this.inject.get(Browser);
        break;
    }
  }

  /**
   * 获取设备类型
   */
  getType(): DeviceType {
    const agent = window.navigator.userAgent.toLowerCase();
    if (/yiban/.test(agent)) {
      return DeviceType.YIBAN;
    }
    if (/miniprogram/.test(agent)) {
      return DeviceType.WECHAT_MICRO;
    }
    if (/yunzai_im/.test(agent)) {
      return DeviceType.YUNZAI_IM;
    }
    if (/dingtalk/.test(agent)) {
      return DeviceType.DINGTALK;
    }
    if (
      /iphone|ipod|ipad/.test(agent) &&
      /mobile/.test(agent) &&
      /yunzai/.test(agent)
    ) {
      return DeviceType.IOS;
    }
    if (
      /android/.test(agent) &&
      /mobile/.test(agent) &&
      /yunzai/.test(agent)
    ) {
      return DeviceType.ANDROID;
    }
    if (/micromessenger/.test(agent)) {
      return DeviceType.WECHAT_MP;
    }
    return DeviceType.BROWSER;
  }
}
